import { createFileRoute } from '@tanstack/react-router';
import { OverviewTab } from '@/features/shipment-detail/overview/overview-tab';

// S02 · Overview (07 §3).
export const Route = createFileRoute('/_app/shipments/$id/')({
  component: OverviewTab,
});
